<template>
  <v-navigation-drawer
    absolute
    temporary
    app
    hide-overlay
    disable
    right
    v-model="drawerRadios.open"
  >
    <v-list three-line>
      <v-subheader>Rádio</v-subheader>
      <v-divider></v-divider>
      <template v-for="(item, index) in getRadios">
        <v-list-tile :key="index">
          <v-list-tile-content>
            <v-list-tile-title>
              <v-layout row>
                <v-flex xs8 style="text-align:left" class="subheading">{{item.name.split("_")[1]}}</v-flex>
                <v-flex
                  xs3
                  style="text-align:center"
                  class="subheading"
                >{{item.total2ghz || 0}} / {{item.total5ghz || 0}}</v-flex>
                <v-flex xs1 style="text-align:right">
                  <div :class="['circle', item.offline > 3 ? 'red' : 'green']"></div>
                </v-flex>
              </v-layout>
            </v-list-tile-title>
            <v-list-tile-subtitle style="color: gray" class="caption capitalize">
              <v-icon small>language</v-icon>
              {{item.ip}}
              <v-icon small>schedule</v-icon>
              <!-- {{item.historico[0].status}} -->
              {{new Date(item.historico[0].date).toLocaleDateString('pt-BR')}} {{new Date(item.historico[0].date).toLocaleTimeString('pt-BR')}}
            </v-list-tile-subtitle>

            <v-list-tile-subtitle>
              <v-sparkline
                v-if="sparklines.hasOwnProperty(item.name)"
                style="width:100%;height: 100%; display: inline-block"
                radius="0"
                padding="1"
                line-width="3"
                :value="sparklines[item.name].devices"
                auto-draw
                responsive="true"
                color="#42B3F4"
                width="600"
              ></v-sparkline>
              <v-progress-circular
                v-else
                :indeterminate="true"
                color="primary"
                :size="20"
                :width="2"
              ></v-progress-circular>
            </v-list-tile-subtitle>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider :key="'div'+ index"></v-divider>
      </template>
      <v-divider></v-divider>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import store from "@/store";
import { mapState } from "vuex";
import Db from "@/Webservices";
import moment from "moment";

const db = new Db();

export default {
  name: "FloatingTab",
  props: { drawer: Object },
  data() {
    return {
      loading: false,
      radios: [],
      vagalumesStatus: [],
      sparklines: {},
      drawerRadios: { open: false },
      intervalId: undefined
    };
  },
  mounted() {
    this.drawerRadios = this.drawer;
  },
  updated() {},
  computed: {
    ...mapState(["client"]),
    getRadios() {
      return this.radios;
    }
  },
  watch: {
    client(newValue) {
      this.loading = true;

      var startDate = moment()
        .subtract(24, "hours")
        .format();
      var endDate = moment().format();

      db.getRadiosByRadioPrefix(newValue.radio_prefix)
        .then(response => {
          this.radios = response.data;

          return db.getVagalumeStatus(
            newValue.radio_prefix,
            startDate,
            endDate
          );
        })
        .then(response => {
          this.vagalumesStatus = this.sumarizeVagalumeData(
            response.data,
            startDate,
            endDate
          );
        });
    }
  },
  methods: {
    sumarizeVagalumeData(vagaDates, startDate, endDate) {
      this.sparklines = {};
      vagaDates.forEach(vagaDate => {
        var radios = vagaDate.radios;
        var datetime = vagaDate.datetime;

        radios.forEach(radio => {
          var name = radio.name;

          var total_stations = radio.interfaces.reduce(
            (acc, curr) => acc + curr.total_stations,
            0
          );

          if (!this.sparklines.hasOwnProperty(name)) {
            this.sparklines[name] = [];
          }

          this.sparklines[name].push({ datetime, total_stations });
        });
      });

      Object.keys(this.sparklines).forEach(key => {
        this.sparklines[key] = segmentData(
          this.sparklines[key],
          startDate,
          endDate
        );
      });

      this.loading = false;
      this.$forceUpdate();
    }
  }
};

function segmentData(data, datetimeStart, datetimeEnd) {
  var dates = [];

  var currDate = moment(datetimeStart).startOf("hours");
  var lastDate = moment(datetimeEnd).startOf("hours");

  while (currDate.add(1, "h").diff(lastDate) < 0) {
    dates.push(currDate.clone().toDate());
  }

  var devices = [];
  var labels = [];

  var dtLast = dates[0];
  var initial = 0;

  dates.forEach(dtCurr => {
    var avg = {
      devices: 0,
      datetime: moment(dtCurr).format("HH:mm")
    };
    var ct = 0;
    var found = false;

    for (var i = initial; i < data.length && !found; i++) {
      var currData = data[i];

      if (moment(currData.datetime).diff(dtCurr, "h") >= 1) {
        found = true;
        initial = i;
      } else {
        avg.devices += currData.total_stations;
        ct++;
      }
    }

    if (ct != 0) {
      avg.devices = Math.ceil(avg.devices / ct);
    }

    devices.push(avg.devices);
    labels.push(avg.datetime);
  });

  return {
    labels: labels,
    devices: devices
  };
}
</script>
<style scoped>
.circle {
  display: inline-block;
  margin-top: auto;
  margin-bottom: auto;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.green {
  background-color: rgb(125, 209, 15);
  background-image: radial-gradient(circle, rgb(14, 240, 25), rgb(36, 189, 6));
}

.red {
  background-color: rgb(209, 44, 15);
  background-image: radial-gradient(circle, rgb(228, 139, 57), rgb(236, 9, 9));
}

.capitalize {
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/FloatingTab.vue